import { Feature } from "geojson";

/**
 * Removes features without geometry, which cannot be loaded into a draw control.
 */
export const filterDrawableFeatures = <F extends Feature>(features: F[]): F[] => features.filter((feature) => feature.geometry != null);
